import * as React from 'react';
import cn from 'clsx';
import { LinkButton } from '@cian/ui-kit';

import { withDeviceType, IWithDeviceTypeProps } from '../../utils/withDeviceType';
import { HowItWorksVideo } from '../HowItWorksVideo';

import * as styles from './styles.css';

interface IHeroSectionProps extends IWithDeviceTypeProps {
  onAboutDealButtonClick(): void;
  onCreateDealButtonClick(): void;
  consultationRequestButton: React.ReactNode;
  dealFormUrl: string;
  videoSrc: string;
  needStopVideo?: boolean;
}

const HeroSection: React.FC<React.PropsWithChildren<IHeroSectionProps>> = ({
  isDesktop,
  deviceType,
  onAboutDealButtonClick,
  onCreateDealButtonClick,
  dealFormUrl,
  consultationRequestButton,
  needStopVideo = false,
}) => {
  return (
    <div className={cn(styles['container'], styles[deviceType])}>
      <div className={cn(styles['text-content'], styles[deviceType])}>
        <h2 className={styles['heading']}>Сделка без похода в&nbsp;банк и МФЦ</h2>
        <p className={styles['description']}>
          Объединили услуги удостоверяющих центров, банков, Росреестра в один удобный и доступный онлайн-сервис для
          проведения сделок
        </p>
        <div className={styles['actions']}>
          <div className={styles['deal-help']}>
            <LinkButton href={dealFormUrl} size="L" fullWidth={!isDesktop} onClick={onCreateDealButtonClick}>
              Провести сделку
            </LinkButton>
            {consultationRequestButton}
          </div>
        </div>
      </div>
      <div className={cn(styles['video-content'], styles[deviceType])}>
        <HowItWorksVideo onClick={onAboutDealButtonClick} deviceType={deviceType} needStopVideo={needStopVideo} />
      </div>
    </div>
  );
};

const HeroSectionWithDeviceType = React.memo(withDeviceType(HeroSection));
export { HeroSectionWithDeviceType as HeroSection };
